import '../../../../../components/Admin/Modals/AdminModal.scss';

import { Modal } from '@trackman/web-shared-components';
import Paragraph from 'components/TextComps/Paragraph';

type Props = {
  open: boolean;
  itemName: string;
  nodeLabel: string;
  usageCount: number;
  onCancel: () => void;
  onConfirmDelete: () => void;
  onViewAffectedParameters: () => void;
};

export const DeleteCategoryNodeModal = ({
  open,
  itemName,
  nodeLabel,
  usageCount,
  onCancel,
  onConfirmDelete,
  onViewAffectedParameters,
}: Props) => {
  const isBlocked = usageCount > 0;

  return (
    <Modal
      className='admin-modal'
      open={open}
      title={`Delete ${itemName}`}
      onClose={onCancel}
      cancelBtn={{ label: isBlocked ? 'Close' : 'Cancel', onClick: onCancel }}
      confirmBtn={
        isBlocked
          ? { label: 'View affected parameters', onClick: onViewAffectedParameters }
          : { label: 'Delete', onClick: onConfirmDelete }
      }
    >
      <div className='modal-body'>
        {isBlocked ? (
          <>
            <Paragraph>
              <>
                {nodeLabel} cannot be deleted because {usageCount} active parameter{usageCount === 1 ? '' : 's'} use its subcategories.
              </>
            </Paragraph>
            <Paragraph>
              <>Move the affected parameters to a different category or subcategory before deleting {nodeLabel}.</>
            </Paragraph>
          </>
        ) : (
          <>
            <Paragraph>
              <>Deleting {nodeLabel} cannot be undone.</>
            </Paragraph>
            <Paragraph>
              <>Are you sure you want to permanently delete {nodeLabel}?</>
            </Paragraph>
          </>
        )}
      </div>
    </Modal>
  );
};

export default DeleteCategoryNodeModal;
